import { Link } from 'react-router-dom';

interface Site {
  id: string;
  name: string;
  rating: number;
  tags: string[];
  description: string;
  logoUrl: string;
  category: string;
}

interface RecommendedSitesProps {
  sites: Site[];
}

export default function RecommendedSites({ sites }: RecommendedSitesProps) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门看片网站推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            经过专业团队严格审核，精选当前体验最优秀的免费在线看片网站
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {sites.map((site, index) => (
            <article
              key={site.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src={site.logoUrl}
                    alt={`${site.name} logo`}
                    className="w-full h-full object-cover"
                    width="56"
                    height="56"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-heading text-base font-semibold text-foreground-900 truncate">
                      {site.name}
                    </h3>
                    {index < 3 && (
                      <span className="flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-bold bg-secondary-500 text-background-50">
                        TOP{index + 1}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="flex items-center gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${
                            i < Math.floor(site.rating)
                              ? 'ri-star-fill text-secondary-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-xs font-semibold text-foreground-700">{site.rating}</span>
                  </div>
                </div>
              </div>

              <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                {site.description}
              </p>

              <div className="flex items-center gap-2 flex-wrap">
                {site.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-md bg-background-100 text-xs text-foreground-600 font-medium"
                  >
                    {tag}
                  </span>
                ))}
                <Link
                  to={`/category/${site.category === '电影' ? 'movie' : site.category === '剧集' ? 'series' : site.category === '综艺' ? 'variety' : site.category === '动漫' ? 'anime' : 'documentary'}`}
                  className="ml-auto px-3 py-1 rounded-md bg-primary-50 text-primary-600 text-xs font-medium hover:bg-primary-100 transition-colors whitespace-nowrap"
                >
                  查看更多 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}